export const getStatusLabel = status => {
  const statusMap = {
    // Payment statuses
    initiated: 'Gestartet',
    pending: 'Ausstehend',
    authorised: 'Autorisiert',
    captured: 'Vollständig abgeschlossen',
    refunded: 'Zurückerstattet',
    partialRefund: 'Teilweise zurückerstattet',
    failed: 'Fehlgeschlagen',
    cancelled: 'Abgebrochen',
    timeout: 'Zeitüberschreitung',
    processed: 'Verarbeitet',
    // Voucher statuses
    active: 'Aktiv',
    waitingForPayment: 'Unbezahlt',
    used: 'Eingelöst',
    locked: 'Gesperrt',
    expired: 'Abgelaufen',
  };
  return statusMap[status] || status;
};

// Payment method codes as Adyen reports them on its notifications. Card payments arrive as the
// card brand ("visa", "mc"), so the label names the card type explicitly — the question staff ask
// here is "PayPal or card?".
export const getPaymentMethodLabel = paymentMethod => {
  const methodMap = {
    paypal: 'PayPal',
    scheme: 'Kreditkarte',
    card: 'Kreditkarte',
    visa: 'Kreditkarte (Visa)',
    mc: 'Kreditkarte (Mastercard)',
    mastercard: 'Kreditkarte (Mastercard)',
    amex: 'Kreditkarte (American Express)',
    diners: 'Kreditkarte (Diners Club)',
    discover: 'Kreditkarte (Discover)',
    jcb: 'Kreditkarte (JCB)',
    cup: 'Kreditkarte (China UnionPay)',
    maestro: 'Debitkarte (Maestro)',
    bcmc: 'Bancontact',
    applepay: 'Apple Pay',
    googlepay: 'Google Pay',
    paywithgoogle: 'Google Pay',
    ideal: 'iDEAL',
    sepa: 'SEPA-Lastschrift',
    sepadirectdebit: 'SEPA-Lastschrift',
    sofort: 'Sofortüberweisung',
    directebanking: 'Sofortüberweisung',
    giropay: 'giropay',
    eps: 'EPS',
    klarna: 'Klarna (Rechnung)',
    klarna_account: 'Klarna (Ratenkauf)',
    klarna_paynow: 'Klarna (Sofort)',
    trustly: 'Trustly',
    twint: 'TWINT',
    blik: 'BLIK',
    swish: 'Swish',
    banktransfer_iban: 'Überweisung',
    foodorderonline: 'Online-Zahlung (Speisenbestellung)',
  };
  const code = paymentMethod ? String(paymentMethod).trim() : '';
  if (!code) return '';
  return methodMap[code.toLowerCase()] || code;
};

// Resolves the payment method of a payment for display. The method lives on the payment itself;
// payments made before the Adyen webhook stored it only carry it inside their raw webhook
// payloads, which is why the newest payload naming one serves as the fallback.
export const resolvePaymentMethodLabel = (payment, fallback = '-') => {
  if (payment?.paymentMethod) {
    return getPaymentMethodLabel(payment.paymentMethod);
  }

  const events = Array.isArray(payment?.webhookEvents) ? payment.webhookEvents : [];
  for (let i = events.length - 1; i >= 0; i--) {
    const method = events[i]?.payload?.paymentMethod;
    if (method) return getPaymentMethodLabel(method);
  }

  return fallback;
};
